import React, { Component } from 'react';

//componentes
import ReporteO from './reporteOtros'

class Index extends Component {

    render(){
        return(
            <div>
                <ReporteO />
            </div>
        );
    }

}
export default Index;